import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { FailedUploadsDialogComponent } from '../../../account/dialogs/failed-uploads-dialog/failed-uploads-dialog.component';
import { UploadObj } from '../../../classes/upload-obj.class';
import { ShareGalleryDialogComponent } from '../../../gallery/dialogs/share-gallery-dialog/share-gallery-dialog.component';
import { GallerySettingsMenuComponent } from '../../../gallery/menus/gallery-settings-menu/gallery-settings-menu.component';
import { DialogService } from '../../../services/dialog.service';
import { ProgressToastService } from '../../../services/progress-toast.service';
import { UploadService } from '../../../services/upload.service';
import { ButtonDirective } from '../../directives/button.directive';
import { DataUnitsBigIntPipe } from '../../pipes/data-units-big-int.pipe';
import { AnimatedSvgComponent } from '../svg/animated-svg.component';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-progress-upload-toasts-item-completed',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ButtonDirective, DataUnitsBigIntPipe, AnimatedSvgComponent],
  templateUrl: './progress-upload-toasts-item-completed.component.html',
  styleUrl: './progress-upload-toasts-item-completed.component.scss',
})
export class ProgressUploadToastsItemCompletedComponent {
  private dialog = inject(DialogService);
  private progressToastService = inject(ProgressToastService);
  private uploadService = inject(UploadService);
  toastId = input.required<string>();
  standalone = input<boolean>();
  uploadedAssetCount = input.required<number>();
  uploadedTotalSize = input.required<number>();
  failedUploads = input.required<UploadObj[]>();
  uploads = input.required<UploadObj[]>();
  gallery = input.required<GalleryDto>();

  showFailedUploads() {
    this.dialog.open(FailedUploadsDialogComponent, {
      failedUploads: this.failedUploads(),
      gallery: this.gallery(),
    });
    this.close();
  }

  openGallerySettingsDialog() {
    this.dialog.open(GallerySettingsMenuComponent, { gallery: this.gallery() });
    this.close();
  }

  openShareDialog() {
    this.dialog.open(ShareGalleryDialogComponent, { gallery: this.gallery() });
    this.close();
  }

  close() {
    if (this.standalone()) return;
    this.progressToastService.removeToast(this.toastId());
    this.uploadService.removeUploads(this.gallery().id);
  }
}
